import { useTranslation } from "react-i18next";
import { LANGUAGES } from "@/i18n";
import { Globe, ChevronDown } from "lucide-react";
import { useState, useRef, useEffect } from "react";

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const current = LANGUAGES.find((l) => l.code === i18n.language) || LANGUAGES[0];

  useEffect(() => {
    const onClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const change = (code) => {
    i18n.changeLanguage(code);
    setOpen(false);
  };

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen((v) => !v)}
        data-testid="language-switcher-toggle"
        className="flex items-center gap-1.5 px-2.5 py-1.5 text-xs font-semibold rounded-xl border border-slate-200 hover:bg-slate-50 text-slate-700 transition"
      >
        <Globe className="w-3.5 h-3.5 text-slate-500" />
        <span className="font-bold">{current.flag}</span>
        <ChevronDown className={`w-3 h-3 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="absolute right-0 top-full mt-2 min-w-[180px] bg-white border border-slate-200 rounded-xl shadow-lg py-1 z-50" data-testid="language-switcher-menu">
          {LANGUAGES.map((l) => (
            <button
              key={l.code}
              onClick={() => change(l.code)}
              data-testid={`language-option-${l.code}`}
              className={`w-full text-left px-3 py-2 text-sm flex items-center gap-3 transition ${
                l.code === current.code ? "text-[#E11D48] bg-red-50 font-semibold" : "text-slate-700 hover:bg-slate-50"
              }`}
            >
              <span className="font-bold text-xs w-6 text-slate-500">{l.flag}</span>
              <span>{l.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
